import { render, staticRenderFns } from "./itemBuyContainer.vue?vue&type=template&id=b8e368c0&"
import script from "./itemBuyContainer.vue?vue&type=script&lang=js&"
export * from "./itemBuyContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports